<template>
  <section style="display: flex; flex-direction: row; align-items: center">
    <div class="leftSidePic" :style="style"></div>
    <div style="flex-direction: column; padding-left: 15px">
        <p class="notifTitle">{{title}}</p> 
        <p class="notifText">{{line1}}</p>
        <p v-if="line2 != 0" class="notifText">{{line2}} days to go</p>
        <p v-else class="notifText">Today</p>
    </div>
  </section>
</template>

<script>

export default {
  props: ["title", "line1", "line2", "color"],

  components: {

  },


  data: () => ({}),
  mounted(){
  },

  computed: {
      style(){
          return{
              'background-color': this.color
          }
      }
    },

  methods:{
    
  },
};
</script>

<style  scoped>
</style>